// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-modal .modal {\n    display: block;\n    top: 30%;\n}\n.container-modal {\n    height: 100%;\n    width: 100%;\n}\n.container-modal .no-btn {\n    float: left;\n}\n.container-modal .yes-btn {\n    float: right;\n}\n.container-modal .yes-btn span{\n    color: white;\n}\n.container-modal .close {\n    float: right;\n}\n.container-modal .modal-backdrop {\n    opacity: 0.3;\n    overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
